import BusinessModelCanvas from '@qpr/business-model-canvas';
import createBMCViewModel from '@qpr/business-model-canvas/views/business-model-canvas-view-model';
import React, { useContext, useEffect } from 'react';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import SIPOCPage from './SIPOC';

const BMCPage = () => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  const { corporateId } = useParams<{ corporateId: string }>();
  const { path } = useRouteMatch();

  const bmcViewModel = createBMCViewModel(corporateId);
  return (
    <Switch>
      <Route path={`${path}sipoc/:businessProcessId/:sipocId?/`} component={SIPOCPage} />
      <Route path={`${path}:businessProcessId/:sipocId?/`} component={SIPOCPage} />
      <Route>
        <BusinessModelCanvas BMCViewModel={bmcViewModel} />
      </Route>
    </Switch>
  );
};

export default BMCPage;
